import { PaginatedResponse } from '@/types';
import { CASES_PREFIX } from '@/pages/CustomerService/constants';
import { customerServiceApi } from '@/pages/CustomerService/services/customer-service.service';

interface BaseSubscribedUser {
  account: string;
  subscriptorType: string;
  caseId: string;
}

export interface SubscribedUser extends BaseSubscribedUser {
  id: string;
  createdAt: string;
  updatedAt: string;
}

interface Frequency {
  timeUnit: string;
  quantity: string;
  caseId: string;
  repeat: string;
}

const caseSubscriptionsApi = customerServiceApi.injectEndpoints({
    endpoints: (builder) => ({
      getSubscribedUsers: builder.query<
        PaginatedResponse<SubscribedUser[]>,
        string
      >({
        query: (caseId) => ({
          url: `${CASES_PREFIX}/${caseId}/subscribers`,
        }),
        transformResponse: (response: PaginatedResponse<SubscribedUser[]>) =>
          response,
        providesTags: ['CaseSubscription'],
      }),
      subscribe: builder.mutation<BaseSubscribedUser, BaseSubscribedUser>({
        query: (data) => ({
          url: '/subscribers',
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['CaseSubscription'],
      }),
      removeSubscription: builder.mutation<void, string>({
        query: (subscriberId) => ({
          url: `/subscribers/${subscriberId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['CaseSubscription'],
      }),
      getFrequency: builder.query<PaginatedResponse<Frequency>, string>({
        query: (caseId) => ({
          url: `${CASES_PREFIX}/${caseId}/schedules`,
        }),
        transformResponse: (response: PaginatedResponse<Frequency>) => response,
        providesTags: ['CaseFrequency'],
      }),
      changeFrequency: builder.mutation<
        Frequency,
        Pick<Frequency, 'quantity' | 'caseId' | 'timeUnit'>
      >({
        query: ({ caseId, quantity, timeUnit }) => ({
          url: '/schedules',
          method: 'POST',
          body: {
            repeat: true,
            quantity,
            caseId,
            timeUnit,
          },
        }),
        invalidatesTags: ['CaseFrequency'],
      }),
  }),
});

export const {
  useGetSubscribedUsersQuery,
  useSubscribeMutation,
  useRemoveSubscriptionMutation,
  useGetFrequencyQuery,
  useChangeFrequencyMutation,
} = caseSubscriptionsApi;